import jackpot from '@/api/front/jackpot-section'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return jackpot.get({ params: {
        ...attrubutes
    }})
  }
}
